<!-- Desktop (lg+): inline buttons -->
<div class="hidden lg:flex items-center gap-2">
  @for (a of actions; track a.id ?? a.label) {
    @if (mode === 'icon' && a.icon) {
      <!-- Icon-only button -->
      <ui-button
        [variant]="a.variant ?? 'secondary'"
        [tone]="a.tone ?? 'outline'"
        appearance="icon"
        size="sm"
        [disabled]="!!a.disabled"
        [loading]="!!a.loading"
        [attr.title]="a.label"
        [attr.aria-label]="a.label"
        (clicked)="a.onClick($event)"
      >
        <fa-icon [icon]="a.icon"></fa-icon>
      </ui-button>
    } @else {
      <!-- Text button (with optional icon when mode is icon-label) -->
      <ui-button
        [variant]="a.variant ?? 'secondary'"
        [tone]="a.tone ?? 'outline'"
        size="sm"
        [disabled]="!!a.disabled"
        [loading]="!!a.loading"
        [attr.title]="a.tooltip || null"
        (clicked)="a.onClick($event)"
      >
        @if (mode === 'icon-label' && a.icon) {
          <fa-icon [icon]="a.icon"></fa-icon>
        }
        <span [class.ml-1]="mode === 'icon-label' && !!a.icon">{{ a.label }}</span>
      </ui-button>
    }
  }
</div>

<!-- Mobile (<lg): ⋯ dropdown -->
<div class="flex lg:hidden">
  <details #dropdownRef class="dropdown dropdown-end">
    <summary class="btn btn-ghost btn-square btn-sm list-none" aria-label="Actions">
      <fa-icon [icon]="faEllipsisH"></fa-icon>
    </summary>
    <ul class="menu menu-sm dropdown-content bg-base-100 rounded-box border border-base-300 shadow-lg z-50 w-48 p-1 mt-1">
      @for (a of actions; track a.id ?? a.label) {
        <li>
          <button
            type="button"
            [disabled]="!!a.disabled"
            [class]="menuItemClass(a)"
            (click)="onMenuClick(a, $event, dropdownRef)"
          >
            @if (a.icon) {
              <fa-icon [icon]="a.icon"></fa-icon>
            }
            <span>{{ a.label }}</span>
          </button>
        </li>
      }
    </ul>
  </details>
</div>